import { useState } from "react";
import InfiltreaFolder from "../../../folder_modals/InfiltreaFolder";
import PennylaneFolder from "../../../folder_modals/PennylaneFolder";
import CustomAccordion from "../../../layout/CustomAccordion";
import Icon1 from "../../../icons/Icon";
import { hasInfiltro } from "../../../hexagone/VisibilityHelpers";
import { EmailItem } from "../../Invoice";
import MissionVMCFolder from "../../../folder_modals/MissionVmcFolder";

export const FolderAdministrationSection = ({
  orgData,
  userData,
  handleFetchData,
  missions_infiltrea,
  invoices_pennylane,
  folderData,
  activity_logs,
  emails,
}) => {
  const [openedEmails, setOpenedEmails] = useState({});

  const [loading_drop = false, setLoadingDrop] = useState(false);

  return (
    <>
      <div className="pb-20 flex flex-col gap-1">
        {folderData.pennylane && (
          <CustomAccordion title="Pennylane" userData={userData}>
            <PennylaneFolder
              invoices_pennylane={invoices_pennylane}
              folderData={folderData}
              userData={userData}
              orgData={orgData}
              handleRefresh={handleFetchData}
            ></PennylaneFolder>
          </CustomAccordion>
        )}
        {folderData.missionvmc_ids && (
          <CustomAccordion title="Missions vmc" userData={userData}>
            <MissionVMCFolder
              folderData={folderData}
              userData={userData}
              orgData={orgData}
              handleRefresh={handleFetchData}
            ></MissionVMCFolder>
          </CustomAccordion>
        )}

        {folderData.client_id !== orgData.id && (
          <CustomAccordion title="Emails envoyés" userData={userData}>
            <div className="flex flex-col gap-1 mt-2">
              {emails.length === 0 && (
                <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-neutral-50 p-2 border-l-3 border-neutral-400 ">
                  <div className="text-h3 text-neutral-400 font-medium   gap-2 flex flex-row items-center">
                    <Icon1 icon_name="email" fill="grey" size={20} />
                    Aucun email envoyé pour ce dossier
                  </div>
                </div>
              )}
              <div className="flex flex-col border-1">
                {emails.map((email, index) => (
                  <div
                    key={index}
                    className={`flex flex-col gap-1 ${index === email.length - 1 ? "" : "border-b-1"}  rounded-md bg-white`}
                  >
                    <EmailItem
                      email={email}
                      openedEmails={openedEmails}
                      setOpenedEmails={setOpenedEmails}
                    ></EmailItem>
                  </div>
                  // <div
                  //   key={index}
                  //   className="flex flex-col gap-1 border-l-4 border-blue-400 p-2 m-2 rounded-xl bg-blue-50"
                  // >
                  //   <div className="flex flex-row justify-between ">
                  //     <div className="text-h3 ">{email.object}</div>
                  //     <div className="text-h3 text-shadow_10">{email.id}</div>

                  //     <div
                  //       className={`text-h3 text-white ${
                  //         email.resend_email_status === "email.complained"
                  //           ? "bg-red-400"
                  //           : email.resend_email_status === "email.bounced"
                  //             ? "bg-red-400"
                  //             : email.resend_email_status === "email.delivered"
                  //               ? "bg-green-400"
                  //               : email.resend_email_status ===
                  //                   "email.delivered_delayed"
                  //                 ? "bg-orange-400"
                  //                 : ""
                  //       }`}
                  //     >
                  //       {email.resend_email_status === "email.complained"
                  //         ? "marqué comme spam"
                  //         : email.resend_email_status === "email.bounced"
                  //           ? "rejeté"
                  //           : email.resend_email_status === "email.delivered"
                  //             ? "reçu"
                  //             : email.resend_email_status ===
                  //                 "email.delivered_delayed"
                  //               ? "temporairement bloqué"
                  //               : ""}
                  //     </div>
                  //   </div>
                  //   <div className="text-h3 flex flex-row   text-shadow_50 gap-2 items-center">
                  //     <Icon1 icon_name="date" fill="grey" size={18}></Icon1>
                  //     {format(email.date.toDate(), "dd/MM/yyyy HH:mm")}
                  //   </div>
                  //   {email.emails?.map((email, index) => (
                  //     <div
                  //       key={index}
                  //       className="text-h3 text-shadow_50 flex flex-row gap-2 items-center"
                  //     >
                  //       <Icon1 icon_name="email" fill="grey" size={18}></Icon1>
                  //       {email}
                  //     </div>
                  //   ))}
                  //   <div className="text-h3 text-shadow_50 whitespace-pre-wrap  ">
                  //     {email.content?.includes("<!DOCTYPE html")
                  //       ? "Rappel envoyé"
                  //       : email.content}{" "}
                  //   </div>
                  // </div>
                ))}
              </div>
            </div>
          </CustomAccordion>
        )}
      </div>
    </>
  );
};
